/* Composeur du Coffret Signature */
(() => {
  'use strict';
  const c = document.querySelector('[data-coffret]');
  if (!c) return;
  const $ = (s) => c.querySelector(s);
  const $$ = (s) => Array.from(c.querySelectorAll(s));
  const N = +c.dataset.n || 4;
  const FAM = { gourmand: 'Gourmand', ambre: 'Ambré & épicé', boise: 'Boisé', floral: 'Floral', fruite: 'Fruité', frais: 'Frais', musc: 'Musqué & poudré' };
  const GENRE = { femme: 'Elle', homme: 'Lui', mixte: 'Mixte' };

  let tous = [];
  try { tous = JSON.parse($('[data-cof-data]').textContent).filter((p) => p.a); } catch (e) { console.error('Coffret : données illisibles', e); }
  const parHandle = Object.fromEntries(tous.map((p) => [p.h, p]));
  const sansAccents = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const echap = (t) => String(t).replace(/[&<>"]/g, (x) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[x]));
  const prix = (x) => {
    const n = Math.round(+x || 0);
    const e = Math.floor(n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    const c = n % 100;
    return `${e}${c ? `,${String(c).padStart(2, '0')}` : ''}\u00a0€`;
  };

  const etat = { slots: [], taille: 0, fam: '', genre: '', q: '', limite: 24 };

  const variante = (p) => {
    const v = p.v[etat.taille] && p.v[etat.taille][3] ? p.v[etat.taille] : p.v.find((x) => x[3]) || p.v[0];
    return { id: v[0], titre: v[1], prix: v[2] };
  };

  /* ---------------------------------------------------------------- liste */
  const liste = () => {
    const q = sansAccents(etat.q);
    const res = tous
      .filter((p) => !etat.fam || p.fs.split(',').includes(etat.fam))
      .filter((p) => !etat.genre || p.g === etat.genre || (etat.genre !== 'mixte' && p.g === 'mixte'))
      .filter((p) => !q || sansAccents(`${p.t} ${p.tr} ${p.n} ${FAM[p.f]}`).includes(q))
      .sort((a, b) => (etat.fam ? (a.f === etat.fam ? 0 : 1) - (b.f === etat.fam ? 0 : 1) : 0) || a.r - b.r);
    const visibles = res.slice(0, etat.limite);
    $('[data-cof-list]').innerHTML = visibles.length ? visibles.map((p) => {
      const dans = etat.slots.includes(p.h);
      const v = variante(p);
      return `<article class="ap-cofcard${dans ? ' is-in' : ''}" data-fam="${p.f}">
        <a class="ap-cofcard__img" href="${p.u}" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">${p.pk ? `<img src="${p.pk}" alt="" loading="lazy">` : ''}</a>
        <div class="ap-cofcard__body">
          <p class="ap-fam ap-card__fam"><span class="ap-dot"></span>${FAM[p.f] || ''}<span class="ap-card__genre">${GENRE[p.g] || 'Mixte'}</span></p>
          <h3 class="ap-cofcard__name">${echap(p.t)}</h3>
          <p class="ap-cofcard__notes">${echap(p.tr || '')}</p>
          <p class="ap-cofcard__price">${prix(v.prix)} <small>${echap(v.titre === 'Default Title' ? '' : v.titre)}</small></p>
        </div>
        <button type="button" class="ap-cofcard__btn" data-toggle="${p.h}" aria-pressed="${dans}">${dans ? 'Retirer' : 'Ajouter'}</button>
      </article>`;
    }).join('') : '<p class="ap-cof__empty">Aucun parfum ne correspond. Essayez une autre famille ou une autre note.</p>';
    $('[data-cof-more]').hidden = res.length <= etat.limite;
  };

  /* ---------------------------------------------------------------- coffret */
  const coffret = () => {
    const choisis = etat.slots.map((h) => parHandle[h]).filter(Boolean);
    const vs = choisis.map(variante);
    const html = [];
    for (let i = 0; i < N; i++) {
      const p = choisis[i];
      if (p) {
        html.push(`<div class="ap-cofslot is-full" data-fam="${p.f}">
          ${p.pk ? `<img src="${p.pk}" alt="">` : ''}
          <span class="ap-cofslot__name">${echap(p.t)}</span>
          <button type="button" class="ap-cofslot__x" data-remove="${p.h}" aria-label="Retirer ${echap(p.t)}"><svg class="ap-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
        </div>`);
      } else {
        html.push(`<div class="ap-cofslot${i === N - 1 ? ' ap-cofslot--free' : ''}"><span class="ap-cofslot__plus">+</span>${i === N - 1 ? '<span class="ap-cofslot__free">Offert</span>' : ''}</div>`);
      }
    }
    $('[data-cof-slots]').innerHTML = html.join('');
    const total = vs.reduce((s, v) => s + v.prix, 0);
    const complet = choisis.length === N;
    const offert = complet ? Math.min(...vs.map((v) => v.prix)) : 0;
    $('[data-cof-count]').textContent = `${choisis.length}/${N}`;
    $('[data-cof-price]').textContent = choisis.length ? prix(total - offert) : '—';
    $('[data-cof-before]').textContent = offert ? prix(total) : '';
    const eco = $('[data-cof-save]');
    eco.hidden = !offert;
    eco.textContent = offert ? `−${prix(offert)}` : '';
    const manque = N - choisis.length;
    $('[data-cof-hint]').textContent = complet ? `Votre coffret de ${N} parfums` : manque === 1 ? 'Plus qu’un parfum : il est offert' : `Encore ${manque} parfums à choisir`;
    $('[data-cof-add]').disabled = !complet;
    c.classList.toggle('is-complete', complet);
  };

  const rendre = () => { liste(); coffret(); };

  const basculer = (h) => {
    const i = etat.slots.indexOf(h);
    if (i >= 0) etat.slots.splice(i, 1);
    else if (etat.slots.length < N) etat.slots.push(h);
    else { window.AP?.toast?.(`Votre coffret est complet : retirez un parfum pour en ajouter un autre.`); return; }
    rendre();
  };

  c.addEventListener('click', async (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.toggle) { basculer(b.dataset.toggle); return; }
    if (b.dataset.remove) { basculer(b.dataset.remove); return; }
    if (b.dataset.cofFam !== undefined) {
      etat.fam = b.dataset.cofFam; etat.limite = 24;
      $$('[data-cof-fam]').forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      liste(); return;
    }
    if (b.dataset.cofGenre !== undefined) {
      etat.genre = b.dataset.cofGenre; etat.limite = 24;
      $$('[data-cof-genre]').forEach((x) => x.classList.toggle('is-on', x === b));
      liste(); return;
    }
    if (b.dataset.cofSize !== undefined) {
      etat.taille = +b.dataset.cofSize;
      $$('[data-cof-size]').forEach((x) => x.classList.toggle('is-on', x === b));
      rendre(); return;
    }
    if (b.hasAttribute('data-cof-more')) { etat.limite += 24; liste(); return; }
    if (b.dataset.ready !== undefined) {
      etat.slots = b.dataset.ready.split(',').filter((h) => parHandle[h]).slice(0, N);
      rendre();
      $('[data-cof-box]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (b.hasAttribute('data-cof-add')) {
      const items = etat.slots.map((h) => ({ id: variante(parHandle[h]).id, quantity: 1 }));
      b.classList.add('is-loading');
      try { await window.AP.cart.add(items); } catch (_) { /* message déjà affiché */ }
      b.classList.remove('is-loading');
    }
  });
  let t;
  $('[data-cof-search]')?.addEventListener('input', (e) => { clearTimeout(t); t = setTimeout(() => { etat.q = e.target.value; etat.limite = 24; liste(); }, 150); });

  // préremplissage : ?p=a,b,c (quiz, fiche parfum)
  const depart = new URLSearchParams(location.search).get('p');
  if (depart) etat.slots = depart.split(',').filter((h) => parHandle[h]).slice(0, N);
  rendre();
})();
